import { render, staticRenderFns } from "./AppKpiTile.vue?vue&type=template&id=22ecaea1&"
import script from "./AppKpiTile.vue?vue&type=script&lang=js&"
export * from "./AppKpiTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports